import antiflick from "@app/providers/scripts/antiflick";
import comscore from "@app/providers/scripts/comscore";
import domains from "@app/providers/scripts/domains";
import {
  permutiveScript,
  permutiveSphl,
} from "@app/providers/scripts/permutive";
import { taboolaScript } from "@app/providers/scripts/taboola";
import VWOAsyncSmartCode from "@app/providers/scripts/VWOAsyncSmartCode";
import useLink from "@hooks/useLink";
import { fetchEnvelope, useLiveRamp } from "@hooks/useLiveRamp";
import useScript from "@hooks/useScript";
import useScriptFunction from "@hooks/useScriptFunction";

export default function HeadScriptProvider(): null {
  // Preconnect Scripts most frequently used
  useLink({
    id: "preconnect-googletagmanager",
    rel: "preconnect",
    href: domains.googletagmanager,
  });
  useLink({
    id: "preconnect-mysph",
    rel: "preconnect",
    href: domains.mysph,
  });
  useLink({
    id: "preconnect-doubleclick",
    rel: "preconnect",
    href: domains.doubleclick,
  });
  useLink({
    id: "preconnect-permutive",
    rel: "preconnect",
    href: domains.permutive,
  });
  useLink({
    id: "preconnect-adtag",
    rel: "preconnect",
    href: domains.adtag,
  });
  useLink({
    id: "preconnect-taboola",
    rel: "preconnect",
    href: domains.taboola,
  });

  // Echobox script
  useScript({
    id: "ebx",
    src: "https://applets.ebxcdn.com/ebx.js",
    async: true,
  });

  // Taboola Script
  useScriptFunction({
    id: "taboola-script",
    value: taboolaScript,
  });

  // Edge Permutive App
  useScript({
    id: "edge-permutive-app",
    src: permutiveScript,
    type: "text/javascript",
  });

  //Permutive SPHL
  useScriptFunction({
    id: "permutive-sphl",
    value: permutiveSphl,
  });

  // Anti flick script
  useScriptFunction({
    id: "anti-flick",
    value: antiflick,
  });

  // VWO script
  useScriptFunction({
    id: "VWOA-async-smart-code",
    value: VWOAsyncSmartCode,
  });

  // ComScore script
  useScriptFunction({
    id: "comscore",
    value: comscore,
  });

  // Live Implementation
  useLiveRamp({ fetchEnvelope });

  return null;
}
